import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, GuardResult, MaybeAsync, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { SecurityService } from '@/core/services/security/security.service';
import { AclWithScope } from '@/core/types/security/acl';

@Injectable()
export class AclGuard implements CanActivate, CanActivateChild {
    constructor(
        private router: Router,
        private security: SecurityService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
        return this.checkRouteActivation(route, state);
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
        return this.checkRouteActivation(childRoute, state);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    private checkRouteActivation(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
        const acl: AclWithScope = route.data['acl'];
        if (acl == null || this.security.hasEnoughAccess(acl.acl, acl.scope)) {
            return true;
        }
        this.router.navigate(['/401']);
        return false;
    }
}
